import { createSiweMessage } from "viem/siwe";
import { getWalletNonce, linkWallet } from "@/services/auth.service";

export const shortAddress = (a) => (a ? `${a.slice(0, 6)}…${a.slice(-4)}` : "");

export async function linkConnectedWallet({ address, chainId, signMessageAsync }) {
  const { nonce } = await getWalletNonce();
  const message = createSiweMessage({
    address,
    chainId,
    domain: window.location.host,
    nonce,
    uri: window.location.origin,
    version: "1",
    statement: "Link this wallet to your PAYD account.",
  });
  const signature = await signMessageAsync({ message });
  return linkWallet({ message, signature });
}
